import * as React from "react";
import { AutoSizer } from "react-virtualized";
import "./style.scss";
import { BaseEditor } from "./BaseEditor";
export class SimpleEditor extends React.Component {
    constructor(props) {
        super(props);
        this.updateContent = (newContent) => {
            if (this.props.onChange !== undefined) {
                const onChange = this.props.onChange;
                onChange(newContent);
            }
        };
    }
    render() {
        return (React.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                overflow: "hidden"
            } },
            React.createElement("div", { style: { flex: "1", padding: "10px" } },
                React.createElement(AutoSizer, null, ({ height, width }) => (React.createElement(BaseEditor, { height: height, width: width, config: {
                        lineNumbers: "off",
                        roundedSelection: false,
                        language: this.props.stdout ? "stdoutLanguage" : "text/plain",
                        theme: "stdoutTheme",
                        scrollBeyondLastLine: false,
                        highlightActiveIndentGuide: false,
                        renderIndentGuides: false,
                        renderLineHighlight: "none",
                        fontSize: 13,
                        folding: true,
                        readOnly: true,
                        minimap: {
                            enabled: false
                        }
                    }, dark: this.props.dark, onChange: this.updateContent, content: this.props.content, isStream: this.props.isStream, isStart: this.props.isStart, scrollToBottom: this.props.updated, isEditable: this.props.editable, saveContent: this.props.content, forceReset: this.props.forceReset }))))));
    }
}
//# sourceMappingURL=SimpleEditor.js.map